import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import {
  ElementRef,
  Injectable,
  NgZone,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { MatDialog, MatTable, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Stop, Stops } from '../../../@core/models/live-route';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { AgmGoogleMapService } from '../../../@core/services/googlemap.service';
import { LabelService } from '../../../@core/services/label.service';
import { OnHoldService } from '../../../@core/services/onhold.service';
import { OptimizationService } from '../../../@core/services/optimization.service';
import { ParcelhistoryService } from '../../../@core/services/parcelhistory.service';
import { RouteService } from '../../../@core/services/route.service';
import { SectorService } from '../../../@core/services/sector.service';
import { StopService } from '../../../@core/services/stop.service';
import { RouteOptimizationService } from '../../../@core/services/stopoptimizaiton.service';
import { NotificationService } from '../../../@core/utils/notification.service';
import { GoogleAddressSearchComponent } from '../../../@theme/components/google-address-search/google-address-search.component';
import * as _ from 'lodash';
import { LiveRouteStatus } from '../../../@core/models/live-route-status';
import { BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LocationService } from '../../../@core/services/location.service';
import { LoadingService } from '../../../@core/services/loading.service';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ProgressSpinnerComponent } from '../../../@theme/components/progress-spinner/progress-spinner.component';
import { OptimizeresultDialogComponent } from '../../../@theme/components/optimizeresult-dialog/optimizeresult-dialog.component';
import { SelectLastStopComponent } from '../../../@theme/components/select-last-stop/select-last-stop.component';
import { DropoffpointService } from '../../../@core/services/dropoffpoint.service';
import { ToastrService } from 'ngx-toastr';
import { PhotoService } from '../../../@core/services/photo.service';
import { Route } from '@angular/router';
import { RouteModel } from '../../../@core/models/route';
import { RouteEndpointPreferenceService } from '../../../@core/services/route-endpoint-preference.service';

@Injectable()
export class DashboardBase {
  @ViewChild('table', { static: true }) table: MatTable<Stop>;
  @ViewChild('content', { static: false }) content;
  additionRouteID: number = 1000000;
  connectedList: any[];
  connectedList2: any[];
  exception: number;
  liveRouteStatus: number;
  public swaptoroutelist: boolean = false;
  public allDropListsIds: string;
  public isLoading = false;
  public IsSelected: any;
  public shouldShow: boolean = false;
  public draggingList: boolean;
  public mapLocationLat: number;
  public mapLocationLong: number;


  constructor(
    public _stopService: StopService,
    public apiProvider: ApiProvider,
    public _optimizationService: RouteOptimizationService,
    public _sectorService: SectorService,
    public _routeService: RouteService,
    public _onholdService: OnHoldService,
    public _loadingService: LoadingService,
    public _locationService: LocationService,
    public _photoService: PhotoService,
    public authenticationService: AuthenticationService,
    public _dropOffPoint: DropoffpointService,
    public agmGoogleMapService: AgmGoogleMapService,
    public OptimService: OptimizationService,
    public _parcelhistoryService: ParcelhistoryService,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public db: AngularFireDatabase,
    public notify: NotificationService,
    public translate: TranslateService,
    public labelService: LabelService,
    public toastrService: ToastrService,
    public _dialog: MatDialog,
    public zone: NgZone,
    public overlay: Overlay,
    public routeEndpointPreferences: RouteEndpointPreferenceService
  ) { }

  scrollingPixel: number = 950;
  public scrollRight(): void {
    this.scroll(this.scrollingPixel);
  }

  public scrollLeft(): void {
    this.scroll(-this.scrollingPixel);
  }

  public scroll(postion: number): void {
    this.content.nativeElement.scrollTo({
      left: this.content.nativeElement.scrollLeft + postion,
      behavior: 'smooth'
    });
  }

  dropRoute(event: CdkDragDrop<Stop[]>) {
    if (!this._stopService.currentStopsValue.HasBeenLocked) {
      this._loadingService.setDisplayInProgress(true);
      if (event.previousContainer.id === 'tableOnHold') {
        if (event.container.id === 'stopTable') {
          this.exception = 708;
          this.liveRouteStatus = 1;
        }

        const StopToMove = event.item.data;
        const InsertAt = event.currentIndex;
        if (!StopToMove.IsSelected) {
          this._onholdService.GetStop(StopToMove.Consol_ID).IsSelected = true;
        }
        this.BatchmoveToInRoute(
          this._onholdService.selectedStops,
          this._stopService.RouteID,
          InsertAt + 1
        );
      } else if (event.container.id === 'stopTable') {
        const StopToMove = event.item.data;
        if (!StopToMove.IsSelected) {
          this._stopService.GetStop(StopToMove.Consol_ID).IsSelected = true;
        }
        if (event.container.data[event.currentIndex].No_Stop >= 0) {
          const InsertAt = event.container.data[event.currentIndex].No_Stop;
          this.BatchmoveToInRoute(
            this._stopService.selectedStops,
            this._stopService.RouteID,
            InsertAt
          );
        } else {
          this._loadingService.setDisplayInProgress(false);
        }
      }
    }
  }

  public BatchmoveToInRoute(
    ListstopToMove: Stop[],
    NewRouteID: number,
    StopNumber: number,
    route: any = null
  ) {
    this.Batchmove(
      ListstopToMove,
      NewRouteID,
      StopNumber,
      LiveRouteStatus.InTransit,
      route
    );
  }
  public BatchmoveToOnHold(ListstopToMove: Stop[], StopNumber: number, route: any = null) {
    //this._loadingService.setDisplayInProgress(true);
    this.Batchmove(
      ListstopToMove,
      ListstopToMove[0].Route_ID,
      StopNumber,
      LiveRouteStatus.Postponed,
      route
    );
  }

  public async Batchmove(
    ListstopToMove: Stop[],
    NewRouteID: number,
    StopNumber: number,
    LiveRouteStatus: number,
    route: any = null
  ) {

    if (route != null) {
      for (const stop of ListstopToMove) {
        console.log(stop);
        if (stop.DeliveryGreen) {
          console.log(route)
          if (!route.IsGreen) {
            if (!this.authenticationService.currentUserValue.AdminTPSLRoute) {
              this.translate.get('green-stop-rights-needed').subscribe((message: string) => {
                this.toastrService.error(message);
              });
              return;
            } else {
            }
          }
        }
      }
    } else {
    }

    if (
      (this._stopService.currentStopsValue.Route_ID == NewRouteID &&
        !this._stopService.currentStopsValue.HasBeenLocked) ||
      this._stopService.currentStopsValue.Route_ID != NewRouteID
    ) {
      this.apiProvider
        .BatchTransferStopToRoute(
          //Commit
          NewRouteID,
          this._sectorService.RouteDate,
          this._stopService.RouteID,
          StopNumber,
          LiveRouteStatus,
          this.authenticationService.currentUserValue.UserID,
          0,
          this._sectorService.SectorID,
          ListstopToMove
        )
        .subscribe((response) => {
          if (ListstopToMove[0].Min_Live_Route_Status != 6) {
            this._sectorService.DecrementStopCount(
              this._stopService.RouteID,
              ListstopToMove.length
            );
          }
          if (LiveRouteStatus != 6) {
            this._sectorService.IncrementStopCount(
              NewRouteID,
              ListstopToMove.length
            );
          }
          this._onholdService.CurrentOnholdDataRoot = response.OnHoldStops;
          this._onholdService.currentOnholdsSubject =
            new BehaviorSubject<Stops>(
              this._onholdService.CurrentOnholdDataRoot
            );
          this._onholdService.currentOnhold =
            this._onholdService.currentOnholdsSubject.asObservable();
          this._onholdService.dataSourceOnhold = new MatTableDataSource<Stop>(
            this._onholdService.CurrentOnholdDataRoot.StopsList
          );
          this._onholdService.StopCount =
            this._onholdService.CurrentOnholdDataRoot.StopsList.length;

          this._stopService.currentStopsSubject = new BehaviorSubject<Stops>(
            response.RouteStops
          );
          this._stopService.currentStops =
            this._stopService.currentStopsSubject.asObservable();
          this._stopService.dataSource = new MatTableDataSource<Stop>(
            this._stopService.currentStopsValue.StopsList
          );
          this._stopService.GetDataFromDataBase();
          this._loadingService.setDisplayInProgress(false);
        });
    } else {
      this._loadingService.setDisplayInProgress(false);
    }
  }

  public ChangeAddress(onestop: Stop) {
    const dialogRef = this.dialog.open(GoogleAddressSearchComponent, {
      height: '750px',
      width: '1400px',
      data: onestop
    });

    dialogRef.afterClosed().subscribe((isUpdated: boolean) => {
      if (isUpdated) {
        this._stopService.initialiseRoute()      }
    });

  }

  public setLastStop(routeId: number) {
    const dialogRef = this.dialog.open(SelectLastStopComponent, {
      height: '500px',
      width: '500px',
      data: routeId
    });
  }

  public highlightItems(stops: Stop[]) {
    for (const item of stops) {
      const el = <HTMLElement>document.querySelector(`#row-${item.Consol_ID}`);
      if (el) {
        el.classList.add('dropped-row');
      }
    }
  }

  public onClickGetRouteEta() {
    // this.agmGoogleMapService.GetDataFromDataBase(this._stopService.RouteID);
  }

  public BatchmoveFromOnHold(
    OldRouteId: number,
    NewRouteId: number,
    insertindex: number,
    ListstopToAdd: Stop[],
    RouteDataList: Stop[],
    OnHoldList: Stop[]
  ) {
    let nextindex: number = insertindex;
    this.Batchmove(
      ListstopToAdd,
      NewRouteId,
      insertindex + 1,
      this.liveRouteStatus
    );
  }
}
